import { render } from "./DetalheAvaria.vue?vue&type=template&id=09b2523f"
import script from "./DetalheAvaria.vue?vue&type=script&lang=js"
export * from "./DetalheAvaria.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__